// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { getCloneDescription } from '../cloneUtils';

// Selectors
import { cloneReachableInstanceCountSelector, cloneInstancesModeSelector } from '../cloneInstancesSelector';

// Actions
import { fetchCloneInstances } from '../cloneInstancesActions';

// Components
import Spinner from '../../../components/loaders/Spinner';
import ElementCloneInstancesPopupContentInfo from './ElementCloneInstancesPopupContentInfo';
import ElementCloneInstancesPopupContentMultiBoards from './ElementCloneInstancesPopupContentMultiBoards';

// Constants
import { CLONE_INSTANCES_UI_MODES } from '../cloneInstancesConstants';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './ElementCloneInstancesPopupContent.scss';

const ElementCloneInstancesPopupContent = (props: { elementId: string; element: ImMNElement }) => {
    const { elementId, element } = props;

    const dispatch = useDispatch();
    const mode = useSelector((state) => cloneInstancesModeSelector(state, props));
    const reachableInstanceCount = useSelector((state) => cloneReachableInstanceCountSelector(state, props));

    // When the popup opens, refresh its instances
    React.useEffect(() => {
        dispatch(fetchCloneInstances({ elementId, checkCloneProps: true, force: false }));
    }, []);

    switch (mode) {
        case CLONE_INSTANCES_UI_MODES.LOADING:
            return (
                <div className="ElementCloneInstancesPopupContentLoading">
                    <Spinner show />
                </div>
            );
        case CLONE_INSTANCES_UI_MODES.ERROR:
            return (
                <ElementCloneInstancesPopupContentInfo className="error">
                    Something went wrong while fetching synced cards
                </ElementCloneInstancesPopupContentInfo>
            );
        case CLONE_INSTANCES_UI_MODES.NO_CLONES:
            return (
                <ElementCloneInstancesPopupContentInfo>
                    All other synced cards have now been removed
                </ElementCloneInstancesPopupContentInfo>
            );
        case CLONE_INSTANCES_UI_MODES.CURRENT_BOARD_ONLY:
            return (
                <ElementCloneInstancesPopupContentInfo className="current-board-only">
                    {getCloneDescription(element, reachableInstanceCount)} on the current board
                </ElementCloneInstancesPopupContentInfo>
            );
        case CLONE_INSTANCES_UI_MODES.MANY_BOARDS:
            return (
                <ElementCloneInstancesPopupContentMultiBoards
                    {...props}
                    reachableInstanceCount={reachableInstanceCount}
                />
            );
        case CLONE_INSTANCES_UI_MODES.PRIVATE_BOARDS:
            return (
                <ElementCloneInstancesPopupContentInfo>
                    <div>All other synced copies are on private boards</div>
                </ElementCloneInstancesPopupContentInfo>
            );
        default:
            return (
                <ElementCloneInstancesPopupContentInfo className="error">
                    Invalid state
                </ElementCloneInstancesPopupContentInfo>
            );
    }
};

export default ElementCloneInstancesPopupContent;
